<template>
	<div :class="['c-avatar', computedSize]">
		<div class="c-avatar__placeholder" v-if="!computedImage">
			<span v-if="initial">{{ initial }}</span>
		</div>
		<img class="c-avatar__image" :src="computedImage" v-if="computedImage" />
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			baseImage: '',
		};
	},
	props: ['size', 'image', 'text', 'domain'],
	watch: {
		domain: {
			handler: function () {
				if (this.domain) {
					this._image = null;
					this.getImageFromDomain(this.domain);
				}
			},
			immediate: true,
		},
	},
	computed: {
		computedSize: function () {
			let size = 'md';
			if (this.size) {
				size = this.size;
			}
			return size;
		},
		initial: function () {
			let initial = null;
			if (this.text) {
				initial = this.text[0];
			}
			return initial;
		},
		computedImage: function () {
			if (this.image) {
				return this.image;
			} else if (this.baseImage) {
				return this.baseImage;
			} else {
				return null;
			}
		},
	},
	methods: {
		getImageFromDomain: function (domain) {
			let image = this.$store.getters['cache/domainImage']('https://' + domain);
			if (image) {
				this.baseImage = image;
			} else {
				this.$store.dispatch('cache/fetchMetadata', 'https://' + domain);
			}
		},
	},
};
</script>

<style lang="scss">
.c-avatar {
	display: inline-block;
	font-size: 13px;

	&__placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		text-transform: uppercase;
		color: rgba(255, 255, 255, 0.9);
		border: rgba(255, 255, 255, 0.4) solid 1px;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.4);
		span {
			margin-bottom: -0.5px;
			line-height: 1;
		}
	}

	&__image {
		position: relative;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background-size: cover;
		background-position: center center;
		border-radius: 3px;

		&:before {
			content: ' ';
			display: block;
			position: absolute;
			height: 100%;
			width: 100%;
			background-color: var(--g2);
			//background-image: url('https://underlineme.com/favicon.ico');
		}
	}

	&.sm {
		width: 20px;
		height: 20px;
		font-size: 10px;
	}

	&.md {
		width: var(--spacer);
		height: var(--spacer);
	}

	&.lg {
		width: 32px;
		height: 32px;
		font-size: 18px;
	}
}
</style>
